export const TRANSLATION_SCOPE = 'patientModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_CRUD_SCOPE = [TRANSLATION_SCOPE, 'crud'];
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
